module.exports = __webpack_public_path__ + "img/KinokoTable24.1772bca5.jpg";